import { render, staticRenderFns } from "./settingPlatform.vue?vue&type=template&id=7001c6e4&scoped=true"
import script from "./settingPlatform.vue?vue&type=script&lang=js"
export * from "./settingPlatform.vue?vue&type=script&lang=js"
import style0 from "./settingPlatform.vue?vue&type=style&index=0&id=7001c6e4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7001c6e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7001c6e4')) {
      api.createRecord('7001c6e4', component.options)
    } else {
      api.reload('7001c6e4', component.options)
    }
    module.hot.accept("./settingPlatform.vue?vue&type=template&id=7001c6e4&scoped=true", function () {
      api.rerender('7001c6e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platList/settingPlatform.vue"
export default component.exports